<progress-spinner *ngIf="isLoading"></progress-spinner>
<mat-dialog-content *ngIf="!isLoading" class="alarms-dialog">
  <div class="modal-background">
    <div class="modal-1-header">
      <div class="title">
        <span class="header"> {{ jmepName }}</span>
      </div>
      <div class="btn-group" (click)="closeDialog()">
        <i class="mdi mdi-close close-icon"></i>
      </div>
    </div>

    <div class="probe-action-items">
      <div class="action-btn-1" (click)="refreshAlarm()">
        <div class="icon-1">
          <span class="material-icons md-16">refresh</span>
        </div>
        <div class="text">Refresh</div>
      </div>
    </div>

    <div *ngIf="jmepAlarmsData && jmepAlarmsData.length === 0" fxLayout="row" class="no-data">
      <div class="center-text">No Alarms found.</div>
    </div>

    <div *ngIf="jmepAlarmsData && jmepAlarmsData.length > 0" class="alarms-tables-container">
      <!-- Interface Alarms Table -->
      <mat-table [dataSource]="interfaceAlarmsData" class="alarms-table interface-alarms">
        <!-- Columns Definition -->
        <ng-container matColumnDef="alarmTitle">
          <mat-header-cell *matHeaderCellDef> Interface Alarms </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.alarmTitle }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="alarmMeasurement">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.alarmMeasurement || '' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="eqInterface">
          <mat-header-cell *matHeaderCellDef> Equipment Interface </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.eqInterfaceStatus && element.eqInterfaceStatus !== '-'">
              <span [style.background-color]="element.eqStatusColor" class="status-circle"></span>
            </ng-container>
            <span [matTooltip]="getEqAlarmTooltip(element)" matTooltipPosition="below">
              {{ element.eqInterfaceStatus || '' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nwInterface">
          <mat-header-cell *matHeaderCellDef> Network Interface </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.nwInterfaceStatus && element.nwInterfaceStatus !== '-'">
              <span [style.background-color]="element.nwStatusColor" class="status-circle"></span>
            </ng-container>
            <span [matTooltip]="getNwAlarmTooltip(element)" matTooltipPosition="below">
              {{ element.nwInterfaceStatus || '' }}
            </span>
          </mat-cell>
        </ng-container>

        <!-- Header and Rows -->
        <mat-header-row *matHeaderRowDef="interfaceDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: interfaceDisplayedColumns"></mat-row>
      </mat-table>

      <!-- Probe Alarms Table -->
      <mat-table [dataSource]="probeAlarmsData" class="alarms-table probe-alarms">
        <!-- Columns Definition -->
        <ng-container matColumnDef="alarmTitle">
          <mat-header-cell *matHeaderCellDef> Probe Alarms </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.alarmTitle }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="alarmMeasurement">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.alarmMeasurement || '' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.status && element.status !== '-'">
              <span [style.background-color]="element.statusColor" class="status-circle"></span>
            </ng-container>
            <span [matTooltip]="getAlarmTooltip(element)" matTooltipPosition="below">
              {{ element.status || '' }}
            </span>
          </mat-cell>
        </ng-container>

        <!-- Header and Rows -->
        <mat-header-row *matHeaderRowDef="probeDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: probeDisplayedColumns"></mat-row>
      </mat-table>
    </div>
  </div>

  <mat-dialog-actions style="justify-content: center">
    <button mat-button (click)="closeDialog()" class="close-btn">Close</button>
  </mat-dialog-actions>
</mat-dialog-content>
